<template>
    <div class="layer">
        <div class="wrap">
            <div class="error_content">
                <div class="error_logo">
                    <img src="@/assets/largeLogo.png" alt="" />
                </div>
                <div class="error_title">
                    <h1>404</h1>
                    <h3>페이지를 찾을 수 없습니다.</h3>
                </div>
                <div class="error_text">
                    <div>
                        <p>죄송합니다. 페이지를 찾을 수 없습니다.</p>
                        <p>
                            존재하지 않는 주소를 입력하셨거나, 요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.
                        </p>
                    </div>
                </div>
                <div class="error_btn" @click="router.back()">
                    <button>뒤로 가기</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import router from "@/router";

    export default {
        setup() {
            return {
                router,
            };
        },
    };
</script>
